'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import util from './setting/util';


var _dofImage = require('../dof-image');

var _dofImage2 = _interopRequireDefault(_dofImage);

var _touch = require('../../mixins/touch');

var _touch2 = _interopRequireDefault(_touch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var icon = require('../setting/icon.base64.js');
var dom = weex.requireModule('dom');
var modal = weex.requireModule('modal');
//   add swipe

var range = function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
};
var THRESHOLD = 0.15;

exports.default = {
  mixins: [_touch2.default],
  components: {
    DofImage: _dofImage2.default
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'mini' //max /medium / mini.
    },

    itemImg: {
      type: String,
      default: ''
    },
    itemImgSize: {
      type: String,
      default: 'mini' //max /medium / mini.
    },
    // image backgroundColor
    imgBgColor: {
      type: String,
      default: '#F8F8F8'
    },

    title: {
      type: String,
      default: '',
      require: true
    },
    tag: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    descColor: {
      type: String,
      default: '#8E969B'
    },

    rightText: {
      type: String,
      default: ''
    },
    placeHolder: {
      type: String,
      default: ''
    },
    rightTip: {
      type: String,
      default: ''
    },
    clickActivied: {
      type: Boolean,
      default: true
    },
    hasMargin: {
      type: Boolean,
      default: false
    },
    hasTopBorder: {
      type: Boolean,
      default: false
    },
    hasSubTopBorder: {
      type: Boolean,
      default: false
    },
    hasBottomBorder: {
      type: Boolean,
      default: false
    },
    hasSubBottomBorder: {
      type: Boolean,
      default: true
    },
    hasArrow: {
      type: Boolean,
      default: true
    },
    cellStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    arrowIcon: {
      type: String,
      default: icon['public_ic_more@3x']
    },

    leftWidth: {
      type: Number,
      default: 0
    },
    rightWidth: {
      type: Number,
      default: 0
    },
    leftBackground: {
      type: String,
      default: '#F56428'
    },
    rightBackground: {
      type: String,
      default: '#F56428'
    }
  },
  data: function data() {
    return {
      offset: 0,
      dragging: false
    };
  },

  // hairong add
  created: function created() {
    this.isIos = weex.config.env.osName == 'iOS';
    console.log('TouchMixin', _touch2.default);
  },


  computed: {
    outputCellStyle: function outputCellStyle() {
      var cellStyle = this.cellStyle,
          disabled = this.disabled;

      if (disabled) {
        return _extends({}, cellStyle, {
          opacity: 0.3
        }, this.wrapperStyle);
      } else {
        return _extends({}, cellStyle, {
          opacity: 1
        }, this.wrapperStyle);
      }
    },
    imgStyle: function imgStyle() {
      var itemImgSize = this.itemImgSize,
          imgBgColor = this.imgBgColor;

      switch (itemImgSize) {
        case 'medium':
          return { width: '56px', height: '56px', backgroundColor: imgBgColor, borderRadius: '28px' };
          break;
        case 'max':
          return { width: '96px', height: '96px', backgroundColor: imgBgColor, borderRadius: '48px' };
          break;
        default:
          return { width: '40px', height: '40px', backgroundColor: imgBgColor, borderRadius: '20px' };
          break;
      }
    },
    subCellStyle: function subCellStyle() {
      switch (this.size) {
        case 'medium':
          return { height: '160px' };
          break;
        case 'max':
          return { height: '184px' };
          break;
        default:
          return { height: '104px' };
          break;
      }
    },
    wrapperStyle: function wrapperStyle() {
      var offset = this.offset,
          dragging = this.dragging,
          leftWidth = this.leftWidth,
          rightWidth = this.rightWidth;

      var style = {
        width: 750 + leftWidth + rightWidth + 'px',
        transform: 'translateX(' + (offset - leftWidth) + 'px)',
        transitionProperty: 'transform',
        transitionDuration: dragging ? '0' : '.6s',
        transitionTimingFunction: dragging ? 'none' : 'cubic-bezier(0.18, 0.89, 0.32, 1)'
      };
      return style;
    },
    rightStyle: function rightStyle() {
      var rightWidth = this.rightWidth,
          rightBackground = this.rightBackground,
          color = this.color,
          size = this.size;

      var style = {
        width: rightWidth + 'px',
        // height: `${height}px`,
        backgroundColor: rightBackground,
        color: color
        // return style
      };console.log('this.subCellStyle', this.subCellStyle);
      return _extends({}, style, this.subCellStyle);
    }
  },
  mounted: function mounted() {
    dom.getComponentRect(this.$refs.dofCell, function (option) {
      // console.log('getComponentRect:', option);
    });
  },

  methods: {
    cellClicked: function cellClicked(e) {
      var disabled = this.disabled;

      !disabled && this.$emit('dofCellClicked', { e: e });
      // console.log("this.isIos", this.isIos)
    },
    rightClick: function rightClick(e) {
      var disabled = this.disabled;

      !disabled && this.$emit('dofCellSwipeClicked', { e: e });
    },


    // special(dom, styles) {
    //   animation.transition(dom, {
    //     styles,
    //     duration: 200, // ms
    //     timingFunction: 'ease',
    //     delay: 100 // ms
    //   });
    // },

    swipeMove: function swipeMove() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.offset = range(offset, -this.rightWidth, this.leftWidth);
      if (this.offset) {
        this.swiping = true;
      } else {
        this.opened = false;
      }
    },
    resetSwipeStatus: function resetSwipeStatus() {
      this.swiping = false;
      this.opened = true;
    },
    open: function open(position) {
      var offset = position === 'left' ? this.leftWidth : -this.rightWidth;
      this.swipeMove(offset);
      this.resetSwipeStatus();
    },
    close: function close() {
      this.offset = 0;
    },
    swipeLeaveTransition: function swipeLeaveTransition(direction) {
      var offset = this.offset,
          leftWidth = this.leftWidth,
          rightWidth = this.rightWidth;

      var threshold = this.opened ? 1 - THRESHOLD : THRESHOLD;

      // right
      if (direction === 'right' && -offset > rightWidth * threshold && rightWidth > 0) {
        this.open('right');
        // left
      } else if (direction === 'left' && offset > leftWidth * threshold && leftWidth > 0) {
        this.open('left');
        // reset
      } else {
        this.swipeMove(0);
      }
    },
    startDrag: function startDrag(event) {
      if (this.disabled) {
        return;
      }
      this.dragging = true;
      this.startOffset = this.offset;
      this.touchStart(event);
    },
    onDrag: function onDrag(event) {
      if (this.disabled) {
        return;
      }
      this.touchMove(event);
      if (this.direction === 'horizontal') {
        // event.preventDefault()
        this.swipeMove(this.deltaX + this.startOffset);
      }
    },
    endDrag: function endDrag(event) {
      if (this.disabled) {
        return;
      }
      this.dragging = false;

      if (this.swiping) {
        this.swipeLeaveTransition(this.offset > 0 ? 'left' : 'right');
      }
    },
    onTransitionend: function onTransitionend() {
      this.swiping = false;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-cell2/index.vue
// module id = 317
// module chunks = 0 1